import React from 'react'


export default function Index(props) {
  return (
    <div className="assessment1-container">
      <div className="assessment1-title">
        Directions
      </div>
      <div className="assessment1-content">
        Now that your ability to remember faces and names has been put to the test separately, let's combine those exercises and see if you remember the name of each guest when presented with their image.
      </div>
      <div className="assessment1-wrap">
        <div onClick={() => props.nextPage()} className="assessment1-start-btn">
          Get started
        </div>
      </div>
    </div>
  )
}
